import joi from "joi";
import { UserPinType } from "../../enums/index.js";
const SAVE_USER_PINS_PATH = '/v2/user-pins';
function save_user_pins_path() {
    return SAVE_USER_PINS_PATH;
}
const schema = joi.object({
    userPins: joi.array().items(joi.object({
        type: joi.string().valid(...Object.values(UserPinType)),
        organizationId: joi.string().when('type', {
            is: UserPinType.Organization,
            then: joi.required(),
            otherwise: joi.forbidden()
        }),
        projectId: joi.string().when('type', {
            is: UserPinType.Project,
            then: joi.required(),
            otherwise: joi.forbidden()
        }),
        applicationId: joi.string().when('type', {
            is: UserPinType.Application,
            then: joi.required(),
            otherwise: joi.forbidden()
        })
    }))
}).required();
export { SAVE_USER_PINS_PATH, save_user_pins_path, schema };
